module.exports = __webpack_public_path__ + "cf85b0f399123fe8c3108f38c23c1f28.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-27.png
// module id = 1763
// module chunks = 0